import React from 'react';
import EmptyState from '@atlaskit/empty-state';

import { EntityLink } from '@/ui';
import { CapabilityEntityLink, ItemHeader } from '@/components/primitive';
import { DAC_DOCS_BASE_URL } from '@/constants';

import * as styles from './styles';

interface DependencyListProps {
  title: string;
  list: EntityLink[];
}

const DependencyList: React.FC<DependencyListProps> = ({ title, list }) => (
  <div css={styles.root}>
    <ItemHeader>{title}</ItemHeader>
    <div css={styles.list}>
      {list.length ? (
        list.map(({ name, publicId }) => (
          <CapabilityEntityLink key={name} name={name} publicId={publicId} />
        ))
      ) : (
        <EmptyState
          header={`No ${title}`}
          description={
            <>
              Learn about how Capability dependencies work in Tome{' '}
              <a
                rel="noopener noreferrer"
                target="_blank"
                href={`${DAC_DOCS_BASE_URL}capabilities/#upstream-dependencies`}
              >
                in our docs.
              </a>
            </>
          }
          imageUrl="/static/integrations.svg"
        />
      )}
    </div>
  </div>
);

export const DownstreamDependencies: React.FC<{
  downstreamDependencies: EntityLink[];
}> = ({ downstreamDependencies }) => (
  <DependencyList title="Downstream Dependencies" list={downstreamDependencies} />
);

export const UpstreamDependencies: React.FC<{
  upstreamDependencies: EntityLink[];
}> = ({ upstreamDependencies }) => (
  <DependencyList title="Upstream Dependencies" list={upstreamDependencies} />
);

export default DependencyList;
